import React, {useEffect, useState} from 'react';
import { useForm } from "react-hook-form";
import apiClient from "../../../utils/apiClient";
import FormSelect from "../../forms/form-control/FormSelect";
import FormSubmitButton from "../../forms/form-control/FormSubmitButton";
import {updateStateValue} from "../../../utils/stateHelpers";
import {isEmpty} from "lodash";
import OPPORTUNITY_REPORT_TYPE_OPTIONS from "../opportunityTypeOptions";

/**
 * Reports filters component
 * @returns {JSX.Element}
 * @constructor
 */
const OpportunityReportsFilters = (prop) => {
    const {filters, setFilters, setTableData} = prop;
    const {register, handleSubmit, errors} = useForm();
    const [disciplines, setDisciplines] = useState([]);
    const [states, setStates] = useState([]);

    useEffect(() => {
        apiClient
        .get('getDisciplines')
        .then(response => {
            setDisciplines(response.data.disciplines);
        });

        apiClient
            .get('getUSAStates')
            .then(response => {
                setStates(response.data.states.map(
                    ({id, abbreviation}) => ({id: id, name: abbreviation})
                ));
            });
    }, []);

    const filterSelectionHandler = (e) => {
        const {id, value} = e.target;
        updateStateValue(setFilters, id, value);
    }

    const onSubmit = (data) => {
        updateStateValue(setFilters,'isLoading', true);
        updateStateValue(setFilters,'isSubmitted', true);

        apiClient
            .post('getOpportunityReport', data)
            .then(response => {
                if (isEmpty(response.data)) {
                    setTableData([]);
                    return;
                }
                setTableData(response.data);
            })
            .catch(function () {
                setTableData([]);
            }).then(function () {
            updateStateValue(setFilters,'isLoading', false);
        });
    }

    return (
        <form
            className="needs-validation container-fluid"
            onSubmit={handleSubmit(onSubmit)}
        >
            <div className="form-row s-gy">
                <FormSelect
                    id="report_type"
                    label="Report Type"
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                    value={filters.report_type}
                    onChange={filterSelectionHandler}
                    options={OPPORTUNITY_REPORT_TYPE_OPTIONS}
                    register={register({required: false})}
                    errors={errors}
                />
                <FormSelect
                    id="discipline_id"
                    label="Discipline"
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                    value={filters.discipline_id}
                    onChange={filterSelectionHandler}
                    options={disciplines}
                    register={register({required: false})}
                    errors={errors}
                    labelEmptyOption="All"
                />
                <FormSelect
                    id="state_id"
                    label="State"
                    name="state_id"
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                    options={states}
                    onChange={filterSelectionHandler}
                    value={filters.state_id}
                    register={register({required: false})}
                    errors={errors}
                    labelEmptyOption="All"
                />
                <FormSubmitButton
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                    label="Show"
                />
            </div>
        </form>
    );
}

export default OpportunityReportsFilters;
